import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { LogoService } from './logo.service';

const service = new LogoService();

export interface LogoState {}

const LogoStore: Module<LogoState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async uploadLogo(context, payload: { tenantId: number; logo: any }) {
         const tenant = await service.postLogo(payload.tenantId, payload.logo);
         context.commit('tenant/SET_TENANT_LOGO', tenant.logo, { root: true });
         return tenant;
      },
   },
};

export default LogoStore;
